__turbopack_context__.v({
  "loader": "styles-module-scss-module__G_81Ia__loader",
});
